/*
    Templatka js ze szczegółami danej ankiety. Szczegóły te wyświetlane są po kliknięciu na ankietę w tabelce Datatables.
 */

export function detailsTemplate(data, id) {
    return `
   <div class="row">
    <div class="col-4">
        <p>
            <i class="bx bx-user font-size-16 align-middle text-primary mr-1"></i>
            Number of respondents entries: ${data.surveyProgress.sum}
        </p>
        <p>
            <i class="bx bx-user-check font-size-16 align-middle text-primary mr-1"></i>
            Number of completed surveys: ${data.surveyProgress.completed}
        </p>
        <p>
            <i class="bx bx-user-x font-size-16 align-middle text-primary mr-1"></i>
            Number of uncompleted surveys: ${data.surveyProgress.uncompleted + data.surveyProgress.excluded}
        </p>
    </div>
    <div class="col-4">
        <div class="d-table">
            <div class="d-table-row">
                <div class="d-table-cell">
                    <p>
                        <i class="bx bx-link font-size-16 align-middle text-primary mr-1"></i>
                        <a href="${data.surveyLink}" target="_blank">
                            Link to the survey
                        </a>
                    </p>
                </div>
                <div class="d-table-cell">
                    <p>
                        <button class="btn waves-effect waves-light btn-primary px-1 py-0 ml-2"
                            data-copy-to-clipboard="${data.surveyLink}">
                            <i class="bx bx-copy font-size-12 align-middle"></i>
                        </button>
                    </p>
                </div>
            </div>
            <div class="d-table-row">
                <div class="d-table-cell">
                    <p>
                        <i class="bx bx-link font-size-16 align-middle text-primary mr-1"></i>
                        <a href="/survey/${id}/status" target="_blank">
                            Link to status without login
                        </a>
                    </p>
                </div>
                <div class="d-table-cell">
                    <p>
                        <button class="btn waves-effect waves-light btn-primary px-1 py-0 ml-2"
                            data-copy-to-clipboard-without-host="/survey/${id}/status">
                            <i class="bx bx-copy font-size-12 align-middle"></i>
                        </button>
                    </p>
                </div>
            </div>
        </div>
        ${redirectionsForm(data.survey)}
    </div>
    <div class="col-4">
        <p>
            <i class="bx bx-data font-size-16 align-middle text-primary mr-1"></i>
            <a href="#" id="manage-data" data-url="/panel/survey/${id}/report/manageData">
                Manage data
            </a>
        </p>
        ${freeReport(data.surveyFreeReport, id)}
        ${latestReport(data.surveyLatestReport)}
    </div>
</div> 
    `;

    function redirectionsForm(survey) {
        let forbidden = ['live', 'completed'];
        if (forbidden.includes(survey.status.label)) {
            return '';
        }

        return `
            <div class="d-table-row">
                <div class="d-table-cell">
                    <p>
                        <i class="bx bx-link font-size-16 align-middle text-primary mr-1"></i>
                        <a href="/survey/${survey.redirects_token}" target="_blank">
                            Link to the redirections form
                        </a>
                    </p>
                </div>
                <div class="d-table-cell">
                    <p>
                        <button class="btn waves-effect waves-light btn-primary px-1 py-0 ml-2"
                            data-copy-to-clipboard-without-host="/survey/${survey.redirects_token}">
                            <i class="bx bx-copy font-size-12 align-middle"></i>
                        </button>
                    </p>
                </div>
            </div>        
        `;
    }

    function freeReport(surveyFreeReport, id) {
        if (!surveyFreeReport.lastReportChanges) {
            return '';
        }
        return `
            <p>
                <i class="bx bx-add-to-queue font-size-16 align-middle text-primary mr-1"></i>
                <a href="/panel/survey/${id}/report/create">
                    Get new report
                </a>
                <br>
            </p>
            ${freeReportDate(surveyFreeReport)}
        `;
    }

    function freeReportDate(freeReport) {
        if (!freeReport.hasFreeReport) {
            return '';
        }
        return `
           <p class="mt-1">
            open access to new reports to: ${freeReport.freeReportDate}
           </p> 
        `;
    }

    function latestReport(surveyLatestReport) {
        if (!surveyLatestReport) {
            return '';
        }
        return `
            <p>
                <i class="bx bx-chart font-size-16 align-middle text-primary mr-1"></i>
                <a href="/panel/survey/report/${surveyLatestReport.id}" class="mr-3 text-primary" data-toggle="tooltip" data-placement="top" title="Summary" data-original-title="Summary">
                    Show latest report
                </a>
            </p>
        `;
    }
}

